import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/* ------------------------------
   📘 TYPES
--------------------------------*/
type CancelOrderState = {
  reason: string;
  amount: string;
  order_id: string;

};

/* ------------------------------
   🧩 INITIAL STATE
--------------------------------*/
export const initialState: CancelOrderState = {
  reason: "",
  amount: "",
  order_id: ""
};

/* ------------------------------
   ⚙️ SLICE
--------------------------------*/
export const CancelOrderSlice = createSlice({
  name: "CancelOrder",
  initialState,
  reducers: {
    setReason: (state, action: PayloadAction<string>) => {
      state.reason = action.payload;
    },
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount = action.payload;
    },
    setOrderId: (state, action: PayloadAction<string>) => {
      state.order_id = action.payload;
    },
    resetCancelOrder: () => initialState,
  },
});

/* ------------------------------
   🚀 EXPORT ACTIONS + REDUCER
--------------------------------*/
export const {
  setReason,
  setAmount,
  setOrderId,
  resetCancelOrder,
} = CancelOrderSlice.actions;

export default CancelOrderSlice.reducer;
